define('models/Podio.Models.LinkedFile',['require','lib/backbone/Backbone.PodioModel'],function(require) {

  var PodioModel = require('lib/backbone/Backbone.PodioModel');

  return PodioModel.extend({

  });

});

